// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"126":"f1f64824","226":"d15c149e","631":"2ead731f","845":"bb5c49bc"}[chunkId] + ".css";
};